import { takeLatest as originaltakeLatest } from 'redux-saga/effects';

import { ActionCreator, IAction } from '../models';

type TakeLatest = {
    <TPayload, TResult>(actionCreator: ActionCreator<TPayload>, handler: (action: IAction<TPayload>) => TResult): ReturnType<
        typeof originaltakeLatest
    >;
    <TPayload1, TPayload2, TResult>(
        actionCreators: [ActionCreator<TPayload1>, ActionCreator<TPayload2>],
        handler: (action: IAction<TPayload1 | TPayload2>) => TResult,
    ): ReturnType<typeof originaltakeLatest>;
};

const takeLatest = originaltakeLatest as TakeLatest;

export { takeLatest };
